import { CurrencyType } from 'enums/currency-type.enum';

import { IWalletCurrency } from '../wallet-currency-response.interface';
import { ITradeBuyer } from './i-trade-buyer.interface';

export interface ITradeOffer {
  id: number;
  // @TODO check if currency_id and currency_type can be removed
  currency: Omit<IWalletCurrency, 'icon' | 'balance'>;
  sale_id: number;
  buyer: ITradeBuyer;
  status: TradeOfferStatus;
  currency_amount: string;
  trade_value: string;
  signature: string;
  expiration_time: number;
  nonce: number;
  state_hash: string;
  currency_id: number;
  currency_type: CurrencyType;
}

export enum TradeOfferStatus {
  ACTIVE = 0,
  FINISHED = 1,
  CANCELLED = 2,
  EXPIRED = 3,
  OVERBID = 4,
}
